import { RefObject, useEffect } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';

/**
 * This checks input refs for pre-filled values that go above the set maxLength.
 * We need this because browser validation for maxLength only gets triggered if the input is dirty (changed by user).
 *
 * See: https://html.spec.whatwg.org/multipage/form-control-infrastructure.html
 * #limiting-user-input-length:-the-maxlength-attribute
 */
export function useValidateTextLength(inputRef: RefObject<HTMLInputElement | HTMLTextAreaElement | null>) {
  const { t } = useSonTranslation('Form');

  useEffect(() => {
    const { current: input } = inputRef;
    const maxLengthIsProvided = input && input.maxLength && input.maxLength >= 0;
    if (maxLengthIsProvided && input.value.length > input.maxLength) {
      input.setCustomValidity(t('tooManyCharacters'));
    }
  }, [inputRef, t]);
}
